import { Component, Input } from '@angular/core';
import { AbstractComponent } from '../../../../../../shared/definition/abstract/abstract.component';
import { HealthAnalysisModel } from '../../../model/health-analysis.model';
import { HealthAnalysisService } from '../../../../health-analysis.service';

@Component({
  selector: 'app-health-analysis-detail-files',
  templateUrl: './health-analysis-detail-files.component.html',
  styleUrl: './health-analysis-detail-files.component.scss'
})
export class HealthAnalysisDetailFilesComponent extends AbstractComponent{
    @Input() analysis: HealthAnalysisModel;
    @Input() files: Array<any>;

    downloading = new Set<number>();

    constructor(public healthAnalysisService: HealthAnalysisService) {
        super();
    }

    protected eventDownloadFile(index: number, event: Event): void {
        this.downloading.add(index);
        const file = this.files[index];
        this.healthAnalysisService.getHealthAnalysisFileDownloadLink(this.analysis.analysisIdentifier, file.name).subscribe((url) => {
            const link = document.createElement('a');
            link.href = url;
            link.download = `${file.name}`;
            link.click();
            this.downloading.delete(index);
        });
    }
}
